var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-wrap"},[_c('el-page-header',{attrs:{"content":"发布新闻"},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('NewForm',{on:{"eventForm":_vm.handleGetForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }